// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";

// Your web app's Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase only if config is valid
let app = null;
try {
  // Validate required Firebase config before initialization
  if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
    console.warn('Firebase configuration is missing. Some features may not work.');
    console.warn('Required: REACT_APP_FIREBASE_API_KEY, REACT_APP_FIREBASE_PROJECT_ID');
  } else {
    app = initializeApp(firebaseConfig);
  }
} catch (error) {
  console.error('Failed to initialize Firebase:', error);
  app = null;
}

// Initialize Analytics (only in browser and if app is initialized)
let analytics = null;
if (typeof window !== "undefined" && app) {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn('Failed to initialize Firebase Analytics:', error);
  }
}

// Initialize Messaging (only in browser and if app is initialized)
let messaging = null;
if (typeof window !== "undefined" && "serviceWorker" in navigator && app) {
  try {
    // Always try to initialize messaging - let Firebase decide if it will work
    // Firebase FCM requires HTTPS or localhost, but we'll attempt anyway
    messaging = getMessaging(app);
    // Only warn if not secure context and not localhost (informational, not blocking)
    const hostname = window.location.hostname;
    if (!window.isSecureContext && window.location.protocol !== 'https:' && hostname !== 'localhost' && hostname !== '127.0.0.1') {
      console.info('ℹ️ Accessing via IP address. FCM token generation may require HTTPS or localhost.');
      console.info('   If token generation fails, use http://localhost:3000 or add IP to Firebase authorized domains.');
    }
  } catch (error) {
    console.warn("Firebase messaging initialization failed:", error.message);
    messaging = null;
  }
}

// VAPID Key for FCM from environment variable
export const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

if (!VAPID_KEY) {
  console.warn('REACT_APP_FIREBASE_VAPID_KEY is not set. Push notifications may not work.');
}

export { app, analytics, messaging };
